import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nConfig } from './lib/i18n.config';

// Initialize i18next as a singleton without provider
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      ...i18nConfig,
      react: {
        useSuspense: false,
      }
    });
}

export default i18n;

